import React, { memo } from "react";
import Switch from "react-switch";
import CustomLabel from '../CustomLabel';
import SVG from 'react-inlinesvg';
import styles from './customSwitch.module.scss';
import { checkCircleSVG, errorCircleSVG } from '../../helpers/icons';

const CustomSwitch = ({ label: _label, onChange, value, showIcon = false, className }) =>
    <div className={`${styles.container} ${className}`}>
        <CustomLabel className={styles.label}>{_label}</CustomLabel>
        <Switch
            checked={value}
            onChange={onChange}
            checkedIcon={
                showIcon && <SVG
                    src={checkCircleSVG}
                    className={`${styles.svg} ${styles.success}`}
                />
            }
            uncheckedIcon={
                showIcon && <SVG
                    src={errorCircleSVG}
                    className={`${styles.svg} ${styles.error}`}
                />
            }
            offColor={styles.thirdBackgroundColor}
            offHandleColor={styles.thirdFontColor}
            onColor={styles.successColor}
            height={24}
            width={46}
        />
    </div>


export default memo(CustomSwitch);
